module.exports = __webpack_public_path__ + "static/media/img4.98c93cdc.jpg";